// frontend/src/components/LogoManager/LogoManager.jsx (VERSÃO ATUALIZADA E VERSÁTIL)
import React, { useState, useEffect } from 'react';
import { Avatar } from 'antd';
import { BankOutlined, CreditCardOutlined, StarOutlined } from '@ant-design/icons'; // Adicionado StarOutlined

const LogoManager = ({ slug, type = 'banco', style: customStyle }) => {
    const [logoUrl, setLogoUrl] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        setLogoUrl(null);
        setError(false);

        if (!slug) {
            setError(true);
            return;
        }

        const loadLogo = async () => {
            // O caminho agora é dinâmico, usando o 'type' para decidir a pasta
            let folder;
            switch (type) {
                case 'banco':
                    folder = 'bancos';
                    break;
                case 'bandeira':
                    folder = 'bandeiras';
                    break;
                case 'programa':
                    folder = 'programas'; // Nova pasta para programas
                    break;
                default:
                    folder = 'bancos';
            }

            // Tenta carregar .svg e depois .png
            try {
                const importedLogo = await import(`../../assets/logos/${folder}/${slug}.svg`);
                setLogoUrl(importedLogo.default);
            } catch (svgError) {
                try {
                    const importedLogoPng = await import(`../../assets/logos/${folder}/${slug}.png`);
                    setLogoUrl(importedLogoPng.default);
                } catch (pngError) {
                    console.error(`Logo não encontrado para o slug: ${slug} no tipo: ${type}`, pngError);
                    setError(true);
                }
            }
        };

        loadLogo();
    }, [slug, type]);

    if (error) {
        // Mostra um ícone de fallback diferente para cada tipo
        let fallbackIcon;
        switch (type) {
            case 'banco':
                fallbackIcon = <BankOutlined />;
                break;
            case 'bandeira':
                fallbackIcon = <CreditCardOutlined />;
                break;
            case 'programa':
                fallbackIcon = <StarOutlined />; // Fallback para programas
                break;
            default:
                fallbackIcon = <BankOutlined />;
        }
        return <Avatar size="large" icon={fallbackIcon} style={customStyle} />;
    }

    if (!logoUrl) {
        return <Avatar size="large" style={customStyle} />; // Mostra um avatar vazio enquanto carrega
    }

    // Estilos padrão que podem ser sobrescritos pelo customStyle
    const defaultStyle = {
        width: '40px',
        height: '40px',
        objectFit: 'contain',
    };

    return (
        <img 
            src={logoUrl} 
            alt={`Logo ${slug}`} 
            style={{ ...defaultStyle, ...customStyle }} 
        />
    );
};

export default LogoManager;